module.exports = __webpack_public_path__ + "static/media/angry.56de366d.svg";